export enum BorderRadiusToken {
  radiusNone = '0',
  radiusCircular = '50%',
  radiusSm = '0.4rem',
  radiusMd = '1.6rem',
}
export default BorderRadiusToken

export type TRadius = 'radiusNone' | 'radiusCircular' | 'radiusSm' | 'radiusMd'
